import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Do I need a special app to use this?",
    a: "No. You can print the pages out on standard paper, or you can open the PDF in any basic tablet annotation app like GoodNotes or Notability.",
  },
  {
    q: "Is this a subscription?",
    a: "Absolutely not. You pay $17 once and you own the files forever. We know how frustrating forgotten subscriptions are, so we refuse to use them.",
  },
  {
    q: "What happens if I forget to use it for a month?",
    a: "Nothing happens. That is the beauty of the system. You just print a new daily sheet and start fresh. The tracker waits for you to come back, no questions asked.",
  },
];

export default function FAQSection() {
  return (
    <section
      data-testid="faq-section"
      className="py-20 md:py-28"
      style={{ backgroundColor: "#1e1e1f" }}
    >
      <div className="max-w-3xl mx-auto px-5 md:px-12">
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight mb-12 text-center"
          style={{ fontFamily: "'Fraunces', serif", color: "#e0e0e0" }}
          data-testid="faq-heading"
        >
          Frequently Asked Questions
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-b"
              style={{ borderColor: "rgba(255,255,255,0.1)" }}
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                className="py-5 text-left text-base md:text-lg font-medium hover:no-underline"
                style={{
                  fontFamily: "'Fraunces', serif",
                  color: "#e0e0e0",
                }}
                data-testid={`faq-trigger-${i}`}
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-base leading-relaxed pb-5"
                style={{
                  fontFamily: "'Inter', sans-serif",
                  color: "#b0b0b5",
                }}
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
